import { ChatList } from './ChatList';
import { Messenger } from './Messenger';
import React, { useCallback, useState } from 'react';
import { Chat, Prompt } from '../../types';
import { createNewChat } from '../../util';
import { ChatType } from '../../dto';
import { useIsSmallerThanTablet } from '../../../responsive/hooks/hooks';
import clsx from 'clsx';
import { DivButton } from '../../../commons/components/DivButton';
import { ChevronLeftIcon } from '../../../assets/icons';
import { ItemListAndDetailsLayout } from '../../../commons/components/ItemListAndDetails';
import { useChatContext } from '../chatContext';

export const ChatListAndMessenger = (props: {
  chatType: ChatType;
  selectedChat: Chat | null;
  onChatSelected: (chat: Chat) => void;
  onOpenLibraryClick?: () => void;
  onOpenVariablesClick?: () => void;
  onPromptClick: (prompt: Prompt) => void;
  onToolCallProceed?: () => void;
  layout?: ItemListAndDetailsLayout;
  systemMessage?: string | (() => string) | null;
}) => {
  const {
    selectedChat,
    onChatSelected,
    onOpenLibraryClick,
    onOpenVariablesClick,
    onPromptClick,
    onToolCallProceed,
    layout,
    systemMessage,
  } = props;

  const {
    chatTypeAndSubtype: { chatType, chatSubtype },
  } = useChatContext();
  const onNewChatClick = useCallback(() => {
    onChatSelected(createNewChat(chatType, chatSubtype));
  }, [onChatSelected, chatType, chatSubtype]);
  const [gptModelSelectDiv, setGptModelSelectDiv] = useState<HTMLDivElement | null>(null);
  const [view, setView] = useState<'messenger' | 'chat-list'>('messenger');
  const isSmallerThanTablet = useIsSmallerThanTablet();
  const effectiveLayout: ItemListAndDetailsLayout =
    layout === 'slim' ? 'slim' : isSmallerThanTablet ? 'slim' : 'two-column';

  const showChatList =
    effectiveLayout === 'two-column' || view === 'chat-list' || selectedChat === null;
  const showMessenger =
    effectiveLayout === 'two-column' || (view === 'messenger' && selectedChat !== null);
  return (
    <div
      className={
        effectiveLayout === 'two-column' ? 'growegy-ai__chat-tab-container' : 'messenger__slim'
      }
    >
      {showChatList && (
        <ChatList
          chatType={chatType}
          chatSubtype={chatSubtype}
          selectedChatId={selectedChat !== null ? selectedChat.id : null}
          onChatSelected={(chat) => {
            onChatSelected(chat);
            setView('messenger');
          }}
        />
      )}
      <div className={showMessenger ? 'messenger__placeholder' : 'd-none'}>
        <div className="messenger__popup-header">
          {effectiveLayout === 'slim' && view === 'messenger' && (
            <>
              <DivButton
                className="messenger__popup-back-button"
                dataTest="messenger__popup-back-button"
                icon={<ChevronLeftIcon />}
                onClick={() => setView('chat-list')}
              />
              <div className="messenger__popup-chat-title">{selectedChat?.title}</div>
            </>
          )}
          <div
            ref={(x) => setGptModelSelectDiv(x)}
            className={clsx('gpt-model-selector__wrapper', {
              'd-none': !(selectedChat !== null),
            })}
            id="chat-model-select-portal-placeholder"
          />
        </div>

        {selectedChat && (effectiveLayout === 'two-column' || view === 'messenger') && (
          <Messenger
            key={`chat-${selectedChat.id}`}
            chat={selectedChat}
            systemMessage={systemMessage}
            gptModelSelectDiv={gptModelSelectDiv}
            slimGptModelSelect={effectiveLayout === 'slim'}
            onChatCreated={onChatSelected}
            onOpenLibraryClick={onOpenLibraryClick}
            onNewChatClick={onNewChatClick}
            onManageVariablesClick={onOpenVariablesClick}
            onPromptClick={onPromptClick}
            onToolCallProceed={onToolCallProceed}
          />
        )}
      </div>
    </div>
  );
};
